import React from 'react';
import { TextLink } from '@vds/buttons';
import PropTypes from 'prop-types';

import { crossSiteCheckUrl } from '../../common/Helpers';
import { appendQueryValues, getFCCCookies } from './constant';
// import { setSessionDetails } from './constant';

export const LanguageLink = ({ onClickFunc }) => {
  const currentLanguage = window.location.href.includes('es-') || window.location.href.includes('espanol') === true ? 'spanish' : 'english';

  const EspañolLink = () => {
    let queryValue = '';
    const { site, category } = getFCCCookies();
    if (site && category) {
      queryValue = appendQueryValues();
    }

    // setSessionDetails();
    if (currentLanguage === 'english') {
      if (window.location.origin.indexOf('qa') > -1) {
        const origin = window.location.href.split('//');
        window.location.href = crossSiteCheckUrl(`https://es-${origin?.[1]}${queryValue}`);
      } else {
        const origin = window.location.href.split('//www.');
        window.location.href = crossSiteCheckUrl(`https://espanol.${origin?.[1]}${queryValue}`);
      }
    } else if (currentLanguage === 'spanish') {
      if (window.location.origin.indexOf('qa') > -1) {
        const origin = window.location.href.split('es-');
        window.location.href = crossSiteCheckUrl(`https://${origin?.[1]}${queryValue}`);
      } else {
        const origin = window.location.href.split('espanol');
        window.location.href = crossSiteCheckUrl(`https://www${origin?.[1]}${queryValue}`);
      }
    }
    if (onClickFunc) {
      // onClickFunc();
    }
  };

  return (
    <div style={{ width: '20%' }}>
      <TextLink
        id="EspañolLink"
        ariaLabel={currentLanguage === 'english' ? 'Español' : 'English'}
        onClick={() => EspañolLink()}
        onKeyPress={() => EspañolLink()}
        analyticstrack={currentLanguage === 'english' ? 'Español' : 'English'}
        tabIndex="0"
        type="standAlone"
        role="link"
        data-track='{"type": "link",  "name": "Español Link"}'
      >
        {currentLanguage === 'english' ? 'Español' : 'English'}
      </TextLink>
    </div>
  );
};

LanguageLink.propTypes = {
  onClickFunc: PropTypes.func,
};
